module.exports = __webpack_public_path__ + "assets/7b0eab6867b7e5af0d036c1deda9adbb.mp3";